import Tooltip from "@mui/material/Tooltip";
import format from "date-fns/format";
import React, { useEffect, useState } from "react";
import { BiInfoCircle } from "react-icons/bi";
import { HiOutlineTicket, HiQrcode } from "react-icons/hi";
import { Ticket } from "../../../models/Ticket";
import "./style.scss";
import ModalComponent from "../../../../features/ModalComponent";
import QrCodeModal from "../../../../features/QRcode";
import { useTranslation } from "react-i18next";
import useOpenToSelect from "../hooks/useOpenToSelect";
import useFacility from "../../../../utils/hooks/useFacility";
import SelectPassBar from "../selectPass/selectPassBar";
import SingleExercise from "../selectPass/singleExercise";
import SelectPassModalFooter from "../selectPass/selectPassModalFooter";
import { useSelector } from "react-redux";
import { State } from "../../../store";
import HtmlTooltip from "@mui/material/Tooltip";
interface IProps {
  ticket: Ticket;
  getSelect: () => void;
}

const LimitedOpenPassDesktop: React.FC<IProps> = ({ ticket, getSelect }: IProps) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [allowToJoin, setAllowToJoin] = useState(false);
  const [assignedList, setAssignedList] = useState(false);
  const { addPossibilityToJoin } = useOpenToSelect();
  const facilityIds = useFacility();
  const allowReservationByPassOnFitnessPlan = useSelector(
    (state: State) => state.config.configuration.allowReservationByPassOnFitnessPlan
  );



  useEffect(() => {
    if (facilityIds === "1212") {
      setAllowToJoin(addPossibilityToJoin(ticket))
    }
  }, [facilityIds]);

  return (
    <React.Fragment>
      {ticket.passtype !== 2 && ticket.ticket === false && (
        <div className="line-horizontal flex-between-center">
          <div className="flex-start-center">
            <HiOutlineTicket className="big-icon" />


            <div className="line-horizontal-text">
              <h3 className="flex-start-center">
                {ticket.name}

                <HtmlTooltip
                  placement="right"
                  title={
                    <React.Fragment>
                      <article
                        className="tooltip-description"
                        dangerouslySetInnerHTML={{ __html: ticket.description }}
                      ></article>
                    </React.Fragment>
                  }
                >
                  <b>
                    <BiInfoCircle className="tooltip-icon" />
                  </b>
                </HtmlTooltip>

              </h3>
              <span>
                {t("wazny_od")}: <b>{format(ticket.validfrom, "dd.MM")}</b> {t("do")}:{" "}
                <b>{format(ticket.validto, "dd.MM.yyyy")}r.</b>
              </span>
            </div>
          </div>
          <div className="line-horizontal-buttons">

            {allowToJoin && (

              <button
                onClick={() => setAssignedList(!open)}
                className="button padding-medium medium button-fill-background-main full-button"
              >
                {t("pokaz_terminy")}
              </button>

            )}


            <button
              onClick={() => setOpen(!open)}
              className="button padding-medium medium button-fill-main full-button"
            >
              {t("pokaz_kod_qr")}
              <HiQrcode className="icon" />
            </button>
          </div>
        </div>
      )}
      {open && (
        <ModalComponent
          footer={false}
          open={open}
          closeModal={() => setOpen(false)}
          title={t("kod_qr")}
          onAccept={() => setOpen(false)}
        >
          <QrCodeModal trhId={ticket.trhId} name={ticket.name} />
          <button
            onClick={() => setOpen(!open)}
            className="button big padding-medium button-fill-second  center-button"
          >
            {t("gotowe_schowaj")}
          </button>
        </ModalComponent>
      )}



      {assignedList && (
        <ModalComponent
          footer={false}
          open={assignedList}
          closeModal={() => setAssignedList(false)}
          title={t("najblizsze_rezerwacje")}
          onAccept={() => setAssignedList(false)}
        >
          <React.Fragment>
            <SelectPassBar ticket={ticket} />

          
              {ticket.exercises[0] && (
                <div>
                  {ticket.exercises.map((exercise, index) => (
                    <div key={index}>
                      <SingleExercise exercise={exercise} getSelect={getSelect} />
                    </div>
                  ))}
                </div>
              )}
        
            {allowReservationByPassOnFitnessPlan && <SelectPassModalFooter ticket={ticket} />}
          </React.Fragment>
        </ModalComponent>
      )}

    </React.Fragment>
  );
};

export default LimitedOpenPassDesktop;
